import { h } from 'preact'
import { useTranslations } from '../../../hooks/useTranslations'
import './styles.scss'

const PaymentTitle = () => {
  const l10n = useTranslations()
  return (
    <tui-payments-title
      className="payment-header__title lead text xxlarge nospace mfe-component"
      data-testid="payment-title"
    >
      {l10n.t('payment-page-title')}
    </tui-payments-title>
  )
}

export default PaymentTitle
